<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="订单id" prop="orderId">
        <a-input-number v-model="form.orderId" placeholder="请输入订单id" style="width: 100%" :min="1" />
      </a-form-model-item>
      <a-form-model-item label="金额" prop="money">
        <a-input-number v-model="form.money" placeholder="请输入金额" style="width: 100%" :min="0" :precision="2" />
      </a-form-model-item>
      <a-form-model-item label="类型" prop="type">
        <a-select v-model="form.type" placeholder="请选择">
          <a-select-option :value="0">用户</a-select-option>
          <a-select-option :value="1">师傅</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="支付类型" prop="bondPayType">
        <a-select v-model="form.bondPayType" placeholder="请选择" allow-clear>
          <a-select-option :value="0">余额支付</a-select-option>
          <a-select-option :value="1">微信</a-select-option>
          <a-select-option :value="2">支付宝</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="支付状态" prop="bondPayStatus">
        <a-select v-model="form.bondPayStatus" placeholder="请选择">
          <a-select-option :value="1">待支付</a-select-option>
          <a-select-option :value="2">已支付</a-select-option>
          <a-select-option :value="3">已取消</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="支付时间" prop="bondPayDate">
        <a-date-picker
          v-model="form.bondPayDate"
          show-time
          format="YYYY-MM-DD HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="请选择支付时间"
          style="width: 100%"
        />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark">
        <a-input v-model="form.remark" placeholder="请输入备注" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">保存</a-button>
          <a-button type="dashed" @click="cancel">取消</a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { addEarnestMoneyOrder, getEarnestMoneyOrder, updateEarnestMoneyOrder } from '@/api/order/earnestMoneyOrder'

export default {
  name: 'CreateForm',
  data() {
    return {
      submitLoading: false,
      formTitle: '',
      form: {
        id: null,
        orderId: null,
        money: null,
        type: 0,
        bondPayType: null,
        bondPayStatus: 1,
        bondPayDate: null,
        remark: null
      },
      formType: 1,
      open: false,
      rules: {
        orderId: [{ required: true, message: '订单id不能为空', trigger: 'blur' }],
        money: [{ required: true, message: '金额不能为空', trigger: 'blur' }]
      }
    }
  },
  methods: {
    onClose() {
      this.open = false
    },
    cancel() {
      this.open = false
      this.reset()
    },
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        orderId: null,
        money: null,
        type: 0,
        bondPayType: null,
        bondPayStatus: 1,
        bondPayDate: null,
        remark: null
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    handleAdd() {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '新增诚意金订单'
    },
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getEarnestMoneyOrder({ id }).then(response => {
        const data = response.data
        this.form = {
          id: data.id,
          orderId: data.orderId,
          money: data.money,
          type: data.type != null ? data.type : 0,
          bondPayType: data.bondPayType,
          bondPayStatus: data.bondPayStatus != null ? data.bondPayStatus : 1,
          bondPayDate: data.bondPayDate,
          remark: data.remark
        }
        this.open = true
        this.formTitle = '编辑诚意金订单'
      })
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.submitLoading = true
        const submit = this.form.id != null ? updateEarnestMoneyOrder(this.form) : addEarnestMoneyOrder(this.form)
        submit
          .then(() => {
            this.$message.success(this.form.id != null ? '修改成功' : '新增成功', 3)
            this.open = false
            this.$emit('ok')
          })
          .finally(() => {
            this.submitLoading = false
          })
      })
    }
  }
}
</script>
